<template>
  <Container type="card-full">
  <div>
    <el-form label-width="80px" class="">
      <el-row>
        <el-col :span="6">
          <el-form-item label="单号" prop="">
            {{form.docno}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="日期" prop="">
            {{form.docdate | date}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button @click="close">关闭</el-button>
        </el-col>
      </el-row>
    </el-form>
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname="" :cols="cols"
            :showfooter="false" :showPage="false" :resizable="true"
            :needBlackRow="false" :needPopMenu="false" :canbeEdit="false">
    </vggrid>
    <!--<br>-->
    <!--<div align="center">-->
      <!--<el-button @click="closeDialog">关闭</el-button>-->
    <!--</div>-->
  </div>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'docthIndex',
    props: {
      //form: {docid: '',doctid: '',docno: '',docdate: ''}
    },
    data () {
      return {
        form: this.$route.params.form,
        list: [],
        cols: [
          { type:  'index',fieldtype: 'C', title: '序号', calculExpr:'',width: 80 },
          { field: 'docthcheckflowname', fieldtype: 'C', title: '审核名称',calculExpr:'', addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '审核人',calculExpr:'',addNewRowFlg: false},
          { field: 'docthchecktime', fieldtype: 'T', title: '审核时间',calculExpr:'',addNewRowFlg: false,formatter:['toDateString', 'yyyy-MM-dd HH:mm:ss']},
          { field: 'docthcheckstatusname', fieldtype: 'C', title: '审核后状态',calculExpr:'',addNewRowFlg: false}
        ],
        query: {
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    activated () {
      this.init()
      this.getPageList()
    },
    created () {
//      console.log('22')
//      this.init()
//      this.getPageList()
    },

    mounted () {
    },
    watch: {
      form (val1,val2) {
//        if (val1.docid!==val2.docid) {
//          console.log('111')
//          this.init()
//          this.getPageList()
//        }
      },
      async '$route' () {
        //this.getPageList()
      }
    },
    components: {vggrid},
    methods: {
      init () {
        this.form = this.$route.params.form
        this.list = []
        this.cols = [
          { type:  'index',fieldtype: 'C', title: '序号', calculExpr:'',width: 80 },
          { field: 'docthcheckflowname', fieldtype: 'C', title: '审核名称',calculExpr:'', addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '审核人',calculExpr:'',addNewRowFlg: false},
          { field: 'docthchecktime', fieldtype: 'T', title: '审核时间',calculExpr:'',addNewRowFlg: false,formatter:['toDateString', 'yyyy-MM-dd HH:mm:ss']},
          { field: 'docthcheckstatusname', fieldtype: 'C', title: '审核后状态',calculExpr:'',addNewRowFlg: false}
        ]
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: this.form.returnForm})
      },

      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/docstat/getDocthList',
          params: this.form
        })
        this.list = res
        this.loading = false
      }
    },
    filters: {
      date (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd')
      }
    }
  }
</script>
<style lang="scss">

</style>
